import seoReducerMap from 'wanderu-ducks-seo';

import CountryGuide from '../containers/CountryGuide/CountryGuide';

function onLoad(module, info, props, context) {
    context.store.inject(seoReducerMap);
}

export { onLoad };
export default CountryGuide;
